import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/layout/index'
Vue.use(Router)
export const constantRoutes = [        
        {
            path: '/login',
            name: 'login',
            hidden:true,
            component: resolve => require(['@/components/login/login'], resolve),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/signup',
            name: 'signup',
            hidden:true,
            component: resolve => require(['@/components/login/signup'], resolve),
            meta: {
                keepAlive: false
            }
        },

        {
            path: '/forget',
            name: 'forget',
            hidden:true,
            component: resolve => require(['@/components/login/forget'], resolve),
            meta: {
                keepAlive: false
            }
        },

        {
            path: '/',
            component: Layout,
            hidden:false,
            redirect: '/Index',
            name:['index'],
            icon:'index',
            children: [{
                path: 'index',
                name: 'index',
                component: resolve => require(['@/components/index/index'], resolve),              
                meta: { keepAlive: false,title:'home' }
            }]
        },
   
        {
            path: '/App',
            component: Layout,
            hidden:false,
            name:['apps','appinfo'],
            redirect: '/App/myapp',
            icon:'myapp',
            children: [
                {
                    path: 'myapp',
                    name: 'apps',
                    component: resolve => require(['@/components/myapp/myapp'], resolve),                        
                    meta: { keepAlive: true,title:'apps'  }
                },
                {
                    path: 'appinfo',
                    name: 'appinfo',
                    component: resolve => require(['@/components/myapp/appinfo'], resolve),                        
                    meta: { keepAlive: false,title:'appinfo'  }
                }
            ]
        },
      

        {
            path: '/Business',
            component: Layout,
            hidden:false,    
            name:['transaction_list','tr_detail','refund_list','refund_detail'],
            redirect: '/Business/transaction_list',
            icon:'business-2',
            children: [                            
                {
                    path: 'transaction_list',
                    name: 'transaction_list',
                    component: resolve => require(['@/components/trading/transaction_list'],resolve),
                    meta: {keepAlive: true,title:'transaction'}
                },
                {
                    path: 'tr_detail',
                    name: 'tr_detail',
                    component: resolve => require(['@/components/trading/tr_detail'],resolve),
                    meta: {keepAlive: false}
                },
                {
                    path: 'refund_list',
                    name: 'refund_list',
                    component: resolve => require(['@/components/refunded/index'],resolve),
                    meta: {keepAlive: true,title:'refund'}
                },
                {
                    path: 'refund_detail',
                    name: 'refund_detail',
                    component: resolve => require(['@/components/refunded/info'],resolve),
                    meta: {keepAlive: false,title:'refund_detail'}
                },

            ]
        }, 

        {
            path: '/Statement',
            component: Layout,
            hidden:true,            
            redirect: '/Statement/statement',
            name:['statement','monthly_report'],    
            icon:'statement',        
            children: [
                {
                    path: 'statement',
                    name: 'statement',
                    component: resolve => require(['@/components/statement/statement'], resolve),                                         
                    meta: { keepAlive:true ,title:'statement'}
                }
                                 
            ]
        }, 

        //黑名单，暂不做
        // {
        //     path: '/BlackList',
        //     component: Layout,
        //     hidden:false,            
        //     redirect: '/BlackList/risk',
        //     name:['risk'],            
        //     children: [
        //         {
        //             path: 'risk',
        //             name: 'risk',
        //             component: resolve => require(['@/components/risk/risk'], resolve),                                         
        //             meta: { keepAlive:true ,title:'black'}
        //         },
                                 
        //     ]
        // }, 

        {
            path: '/Notice',
            component: Layout,
            hidden:false,       
            name:['notice','notice_details'],                     
            redirect: '/Notice/index',
            icon:'notice',
            children: [
                {
                    path: 'index',
                    name: 'notice',
                    component: resolve => require(['@/components/notice/index'],resolve),                                                        
                    meta: { keepAlive:false,title:'notice' }
                },
                {
                    path: 'notice_details',
                    name: 'notice_details',
                    component: resolve => require(['@/components/notice/notice_details'],resolve),                                                        
                    meta: { keepAlive:false,title:'notice_details'  }
                }                                
            ]
        },

        {
            path: '/Withdraw',
            component: Layout,
            hidden:true,            
            name:['withdraw','mybank','mybank_details'],                        
            redirect: '/Withdraw/withdraw',
            children: [                
               {
                    path: 'withdraw',
                    name: 'withdraw',
                    component: resolve => require(['@/components/withdraw/withdraw'], resolve),
                    meta: {keepAlive: true,title:'withdraw'}
                },
                {
                    path: 'mybank',
                    name: 'mybank',
                    component: resolve => require(['@/components/withdraw/mybank'], resolve),
                    meta: {keepAlive: false}
                },
                {
                    path: 'mybank_details',
                    name: 'mybank_details',
                    component: resolve => require(['@/components/withdraw/mybank_details'], resolve),
                    meta: {keepAlive: false}
                },
            ]
        },

        {
            path: '/Merchant',
            component: Layout,
            hidden:true,            
            redirect: '/Merchant/create_merchant',
            children: [
                {
                    path: 'create_merchant',
                    name: 'create_merchant',
                    component: resolve => require(['@/components/index/create_merchant'], resolve),                                         
                    meta: { keepAlive:false }
                },
                {
                    path: 'merchant',
                    name: 'merchant',
                    component: resolve => require(['@/components/index/merchant'], resolve),                                         
                    meta: { keepAlive:false }
                },
                {
                    path: 'merchant_info',
                    name: 'merchant_info',
                    component: resolve => require(['@/components/index/merchant_info'], resolve),                                         
                    meta: { keepAlive:false }
                },
                {
                    path: 'email_config',
                    name: 'email_config',
                    component: resolve => require(['@/components/index/email_config'], resolve),                                         
                    meta: { keepAlive:false }
                }               
            ]
        }, 

        {
            path: '/Setting',
            component: Layout,
            hidden:true,   
            redirect: '/Setting/set',
            children: [
                {
                    path: 'set',
                    name: 'set',
                    component: resolve => require(['@/components/user/set'],resolve),                                                        
                    meta: { keepAlive:false }
                }
            ]                
        },

        {
            path: '/Error',
            component: Layout,
            hidden:true,   
            redirect: '/Error/need_bind',
            children: [
                {
                    path: 'need_bind',
                    name: 'need_bind',
                    component: resolve => require(['@/components/error/need_bind'], resolve),                                                                        
                    meta: { keepAlive:false }
                }
            ]                
        },

        {
            path: '/SubAccount',
            component: Layout,
            hidden:false,
            is_super:true,
            name:['accounts','accounts_add','accounts_info'],
            redirect: '/SubAccount/accounts',
            icon:'child_account',
            children: [
                {
                    path: 'accounts',
                    name: 'accounts',
                    component: resolve => require(['@/components/accounts/accounts'], resolve),                        
                    meta: { keepAlive: true,title:'child_account'  }
                },
                {
                    path: 'accounts_add',
                    name: 'accounts_add',
                    component: resolve => require(['@/components/accounts/add'], resolve),                        
                    meta: { keepAlive: false,title:'accounts_add'  }
                },
                {
                    path: 'accounts_info',
                    name: 'accounts_info',
                    component: resolve => require(['@/components/accounts/info'], resolve),                        
                    meta: { keepAlive: false,title:'accounts_info'  }
                }
            ]
        },
        //  {

        //     path: '/set',         
        //     name: 'set',
        //     component: resolve => require(['@/components/user/set'], resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },



        // {
        //     path: '/create_merchant',
        //     name: 'create_merchant',
        //     component: resolve => require(['@/components/index/create_merchant'], resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },
        // {
        //     path: '/merchant',
        //     name: 'merchant',
        //     component: resolve => require(['@/components/index/merchant'], resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },
        // {
        //     path: '/merchant_list',
        //     name: 'merchant_list',
        //     component: resolve => require(['@/components/index/merchant_list'], resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },
        // {
        //     path: '/merchant_info',
        //     name: 'merchant_info',
        //     component: resolve => require(['@/components/index/merchant_info'], resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },
        // {
        //     path: '/email_config',
        //     name: 'email_config',
        //     component: resolve => require(['@/components/index/email_config'], resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },




        // {
        //     path: '/',
        //     name: 'index',
        //     component: resolve => require(['@/components/index/index'], resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },
        // {
        //     path: '/index',
        //     name: 'index',
        //     component: resolve => require(['@/components/index/index'], resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },

        
        // {
        //     path: '/myapp',
        //     name: 'myapp',
        //     component: resolve => require(['@/components/myapp/myapp'], resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },
        // {
        //     path: '/appinfo',
        //     name: 'appinfo',
        //     component: resolve => require(['@/components/myapp/appinfo'], resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },


        // {
        //     path: '/withdraw',
        //     name: 'withdraw',
        //     component: resolve => require(['@/components/withdraw/withdraw'], resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },
        // {
        //     path: '/withdraw/mybank',
        //     name: 'mybank',
        //     component: resolve => require(['@/components/withdraw/mybank'], resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },
        // {
        //     path: '/withdraw/mybank_details',
        //     name: 'mybank_details',
        //     component: resolve => require(['@/components/withdraw/mybank_details'], resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },

        // {
        //     path: '/transaction_list',
        //     name: 'transaction_list',
        //     component: resolve => require(['@/components/trading/transaction_list'],resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },
        // {
        //     path: '/tr_detail',
        //     name: 'tr_detail',
        //     component: resolve => require(['@/components/trading/tr_detail'],resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },
        // {
        //     path: '/ban',
        //     name: 'ban',
        //     component: resolve => require(['@/components/ban/ban'],resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },
        // {
        //     path: '/refunded',
        //     name: 'refunded',
        //     component: resolve => require(['@/components/refunded/index'],resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },


        

        // {
        //     path: '/white',
        //     name: 'white',
        //     component: resolve => require(['@/components/white/index'],resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },


        // {
        //     path: '/ban_info',
        //     name: 'ban_info',
        //     component: resolve => require(['@/components/ban/ban_info'],resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },

        // {
        //     path: '/rolling',
        //     name: 'rolling_list',
        //     component: resolve => require(['@/components/rolling/rolling_list'],resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },

        // {
        //     path: '/monthly_report',
        //     name: 'monthly_report',
        //     component: resolve => require(['@/components/statement/monthly_report'],resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },
        // {
        //     path: '/statement',
        //     name: 'statement',
        //     component: resolve => require(['@/components/statement/statement'],resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },




        
        // {
        //     path: '/shipping',
        //     name: 'shipping',
        //     component: resolve => require(['@/components/shipping/shipping_list'],resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },
        // {
        //     path: '/express_company',
        //     name: 'express_company',
        //     component: resolve => require(['@/components/shipping/express_company'],resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },


        
        // {
        //     path: '/chargeback',
        //     name: 'chargeback',
        //     component: resolve => require(['@/components/chargeback/chargeback_list'],resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },

        // {
        //     path: '/fraud',
        //     name: 'fraud',
        //     component: resolve => require(['@/components/fraud/index'],resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },

       
        // {
        //     path: '/chargeback_detail',
        //     name: 'chargeback_detail',
        //     component: resolve => require(['@/components/chargeback/chargeback_detail'],resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },
        // {
        //     path: '/risk',
        //     name: 'risk',
        //     component: resolve => require(['@/components/risk/risk'],resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },


        
        // {
        //     path: '/error/need_bind', // -346状态码会调到need_bind页面            
        //     name: 'need_bind',
        //     component: resolve => require(['@/components/error/need_bind'], resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },
        // {
        //     path: '/error', // 页面不存在的情况下会跳到404页面            
        //     name: 'error',
        //     component: resolve => require(['@/components/error/error'], resolve),
        //     meta: {
        //         keepAlive: false
        //     }
        // },
        // {
        //     path: '/success', // result           
        //     name: 'success',
        //     component: resolve => require(['@/components/error/success'], resolve),            
        // },
        // {
        //     path: '/failed', // result           
        //     name: 'failed',
        //     component: resolve => require(['@/components/error/failed'], resolve)
        // },
        // {
        //     path: '/pending', // result           
        //     name: 'pending',
        //     component: resolve => require(['@/components/error/pending'], resolve)
        // },
        // {
        //     path: '/upload-1', // result           
        //     name: 'upload-1',
        //     component: resolve => require(['@/components/information/upload-1'], resolve)
        // },
        // {
        //     path: '/error/update',
        //     name: 'update',
        //     component: resolve => require(['@/components/error/update'], resolve)
        // },
        // {
        //     path: '/flag', // result           
        //     name: 'flag',
        //     component: resolve => require(['@/components/information/flag'], resolve)
        // },

        
       


    ]


const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}


export default router




// WEBPACK FOOTER //
// ./src/router/index.js